export const CHANGE_CALCULATION_LOADING_STATUS = 'CHANGE_CALCULATION_LOADING_STATUS';

export const changeCalculationLoadingStatusAction = (calculationLoadingStatus) => {
    return {
        type: CHANGE_CALCULATION_LOADING_STATUS,
        payload: calculationLoadingStatus
    }
}